import { Component, inject, Injector, viewChild } from '@angular/core';
import { JkBaseOption, JkComboboxComponent, JkdaterangeComponent, LoginService, OrmService, jkLib, login } from 'jk-service';
import { MaterialModule, } from 'jk-service';
import { SeaFutureOrderComponent } from "../sea-future-order/sea-future-order.component";
import { TwStockOrderComponent } from '../tw-stock-order/tw-stock-order.component';
import { FutureOrderComponent } from '../components/future-order/future-order.component';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, JkBatchComponent, JkmultiselectComponent } from 'jk-advcom';
import { StkmbService } from '../services/stkmb.service';

/**
 * stkpb04 頁面的選項資料模型
 */
class Stkpb04Option extends JkBaseOption { // ###
  /**
   * 開始日期
   */
  date1: string = '';
  /**
   * 結束日期
   */
  date2: string = '';
  /**
   * 工作人員列表
   */
  userList: any[] = [];
  /**
   * 當前登入的使用者ID
   */
  uid: string;// = this.login.userid;
  constructor(name: string) {// ###
    super(name);
    this.uid = login.userid;
    this.date1 = jkLib.nowDate();
    this.date2 = jkLib.nowDate();

    this.userList.push({ id: this.uid, name: this.uid });
  }
  /**
   * 初始化頁面選項，載入工作人員列表
   */
  override init() {
    super.init();
    // 從後端獲取工作人員列表
    this.orm.getopenwin('CMSMV', 'W01', 'W')
      .subscribe((data) => {
        this.userList = data;
        this.cdr.markForCheck();
      });
  }

}


/**
 * 下單作業 (stkpb04)
 * 這是一個批次作業組件，用於處理下單相關的批次任務。
 * 可能是報表產生或是資料處理。
 */
@Component({
  selector: 'app-stkpb04',
  standalone: true,
  imports: [JackBaseComponentModule,
    TwStockOrderComponent, SeaFutureOrderComponent, FutureOrderComponent, AdvComModule,
    MaterialModule],
  templateUrl: './stkpb04.component.html',
  styles: []
})
export class Stkpb04Component extends JkBatchComponent {
  /**
   * 程式代號
   */
  override _programId = 'stkpb04';
  /**
   * 日期範圍選擇元件
   */
  readonly rgDate = viewChild.required<JkdaterangeComponent>('rgDate');
  /**
   * 下拉式選單元件 (未使用)
   */
  readonly mtrwd017 = viewChild.required<JkComboboxComponent>('mtrwd017');
  /**
   * 多選元件 (未使用)
   */
  readonly stkmj001 = viewChild.required<JkmultiselectComponent>('stkmj001');
  /**
   * 頁面選項物件
   */
  pageOpt: Stkpb04Option = new Stkpb04Option(this.programId);//###
  stkmbSrv = inject(StkmbService);

  constructor() {
    super();
    this.setFormOpt2('');
    // 報表類型相關設定 (已註解)
    //this.reportType = '1';
    //this.reportTypeList = [{ id: '1', name: '(1)日期別' },{ id: '1', name: '(1)客戶別' },{ id: '3', name: '(3)工作人員別' }];
  }
  /**
   * 產生 SQL 查詢語句 (目前未實作)
   */
  async makeSql() {
  }
  /**
   * 執行批次作業 (目前為註解範例)
   * 透過 job.addOption 將頁面上的選項加入到批次任務中，
   * 然後呼叫 job.jobInsert 提交任務。
   */
  async doBatch() {
    /*this.job.options = [];
    //xName xCaption xKind xData xType xPs
    this.job.addOption("cboReportType", "報表格式", "TjkComboBox", this.reportType,"", "" );
    this.job.addOption("rgWD002", "工作日期", "TJKRange", this.pageOpt.date1 + "～" + this.pageOpt.date2, "", "");
    this.job.addOption("msWD014", "員工代號", "TjkMultiSelect", this.pageOpt.uid, "", "");
    this.ret = await this.job.jobInsert(login.host, "3"); //空白 或 3    空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知
    if (this.ret.result) {
      //this.navigateTo('/reportview');
    }*/
  }
  /**
   * 立即執行批次作業 (目前未實作)
   */
  async doBatchNow() {

  }
}
